// Shared constants used across the app

// Classic game-piece colors: bold, saturated, unmistakable.
// Inspired by Among Us, Carcassonne, Risk — 8 basic named colors.
// Every color is one a child can name. No pastels, no theory.
export const PLAYER_COLORS = [
  '#D32F2F', // 0: Red    (Deeper red for dark-bg visibility)
  '#F57C00', // 1: Orange (Darker orange, well separated from yellow)
  '#FFF13B', // 2: Yellow (Bright lemon yellow, clearly distinct from orange)
  '#00B341', // 3: Green  (Classic kelly green)
  '#00FFFF', // 4: Cyan   (Max-brightness neon cyan)
  '#1976D2', // 5: Blue   (Darker, solid blue — contrasts with cyan)
  '#9B30FF', // 6: Purple (Bold violet-purple)
  '#FF80AB', // 7: Pink   (Light pastel pink — won't blend with red)
];

// Accessibility: unique symbol per player for colorblind support (double coding).
// Displayed inside markers and board cells alongside color.
export const PLAYER_SYMBOLS = ['●', '▲', '■', '◆', '★', '✦', '◀', '⬟'];

// Accessibility: keep symbol glyphs in one fixed high-contrast style everywhere.
export const COLORBLIND_SYMBOL_COLOR = '#FFFFFF';
export const COLORBLIND_SYMBOL_TEXT_SHADOW = '0 1px 2px rgba(0,0,0,0.95), 0 0 1px rgba(0,0,0,1)';

export const GLOBAL_CHAT_ROOM = '_GLOBAL';
